import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


import Login from '@/store/modules/Usuario.module.js';
import CorreoAlternativo from '@/store/modules/CorreoAlternativo.module.js';
import PromocionesEmpresariales from '@/store/modules/PromocionesEmpresariales.module.js';
import Solicitud from '@/store/modules/Solicitud.module.js';
import utils from '@/store/modules/utils.module.js';
import Dominios from '@/store/modules/Dominios.module.js';
import Documentos from '@/store/modules/Documentos.module.js'

import Ampliacion from '@/store/modules/Ampliacion.module.js'
import DesistimientoRenuncia from '@/store/modules/DesistimientoRenuncia.module.js';
import DocumentosPosteriores from '@/store/modules/DocumentosPosteriores.module.js';
import DetalleInclusionExclusion from '@/store/modules/DetalleInclusionExclusion.module.js';
import BandejaComun from '@/store/modules/BandejaComun.module.js';
import AclaracionComplementacionEnmienda from '@/store/modules/AclaracionComplementacionEnmienda.module.js';
import types from '@/store/types/utils'
import SolicitudCredenciales from '@/store/modules/SolicitudCredenciales.module.js'
import Sorteador from '@/store/modules/Sorteador.module.js'

export default new Vuex.Store({
  state: {
    datosSession:{},
    sessionIciado:false
  },
  mutations: {
    cargarDatosLoginSession(state,pObjDatosSession){
      state.datosSession = pObjDatosSession.message;
      localStorage.setItem('pObjDatosSession', JSON.stringify(pObjDatosSession.message));
      if(pObjDatosSession.status === 200) {
        state.sessionIciado = true;
        localStorage.setItem('sessionIciado', true)
      }
      else {
        state.sessionIciado = false;
        localStorage.setItem('sessionIciado', false)
      }
    },
    vaciarDatosSession(state){
      state.datosSession = {};
      localStorage.removeItem('pObjDatosSession');
      state.sessionIciado = false;
      localStorage.removeItem('sessionIciado');
      localStorage.removeItem('cargarDatosLoginSession');
      localStorage.removeItem('pObjDatosRepLegal');
      localStorage.removeItem('verificoInformacionEmpresa');
      this.commit(types.mutations.SetdialogProgress, false)
    },
    actualizarDatosSession(state,pObjDatosSession){
      localStorage.setItem('pObjDatosSession', JSON.stringify(pObjDatosSession));
      state.datosSession = pObjDatosSession;
    },
    initialiseSession(state) {
      if (localStorage.getItem('pObjDatosSession')) {
        state.datosSession = JSON.parse(localStorage.pObjDatosSession)
      }
      if (localStorage.getItem('sessionIciado')){
        state.sessionIciado = JSON.parse(localStorage.sessionIciado)
      }
    },
    cargarDatosRepresentantesLegalSession(state,pObjDatosRepLegales){
       if (localStorage.getItem('pObjDatosRepLegal')) {
          localStorage.setItem('pObjDatosRepLegal', JSON.stringify(pObjDatosRepLegales.result));
       }
    }
  },
  actions: {

  },
  modules:{
    Login,
    CorreoAlternativo,
    PromocionesEmpresariales,
    Solicitud,
    utils,
    Dominios,
    Documentos,
    Ampliacion,
    DesistimientoRenuncia,
    DocumentosPosteriores,
    DetalleInclusionExclusion,
    BandejaComun,
    AclaracionComplementacionEnmienda,
    SolicitudCredenciales,
    Sorteador,
  }
})
